import { Delete } from "lucide-react";

const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "0", "del"];

export function NumPad({ value, onChange, testid = "numpad", allowDot = true, compact = false }) {
  const press = (k) => {
    if (k === "del") return onChange(value.slice(0, -1));
    if (k === "." && (!allowDot || value.includes("."))) return;
    if (value.length >= 9) return;
    onChange(value === "0" && k !== "." ? k : value + k);
  };
  return (
    <div dir="ltr" className="grid grid-cols-3 gap-2">
      {KEYS.map((k) => (
        <button
          key={k}
          type="button"
          data-testid={`${testid}-key-${k === "." ? "dot" : k}`}
          onClick={() => press(k)}
          disabled={k === "." && !allowDot}
          className={`${compact ? "h-11 text-xl" : "h-12 sm:h-14 text-2xl"} rounded-xl bg-secondary hover:bg-accent font-black shadow-sm active:scale-95 transition-transform disabled:opacity-30`}
        >
          {k === "del" ? <Delete className="mx-auto w-6 h-6" /> : k}
        </button>
      ))}
    </div>
  );
}

export function AmountDisplay({ value, label, testid }) {
  return (
    <div className="rounded-xl bg-white border border-border px-4 py-3">
      {label && <div className="text-xs font-semibold text-muted-foreground">{label}</div>}
      <div dir="ltr" className="text-3xl font-extrabold tracking-tight text-end" data-testid={testid}>{value || "0"}</div>
    </div>
  );
}
